import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="refresh-elements"
export default class extends Controller {
  connect() {
    this.element.addEventListener(
      "turbo:frame-render",
      this.refreshElements.bind(this)
    );

    this.refreshElements();
    window.initializeTimepickers()
  }

  disconnect() {
    this.element.removeEventListener(
      "turbo:frame-render",
      this.refreshElements.bind(this)
    );
  }

  refreshElements() {
    const $elem = $(this.element);


    $elem.find(".datepicker").datepicker();
    $elem.find(".timepicker").timepicker();
    $elem.find(".metafield-timepicker").timepicker();
    //intializeTimepickers happens before turboframe loads, so this needs to be defined now
    $elem.find(".visit-metafield-timepicker").timepicker({
      showMeridian: false,
      showSeconds: false,
      minuteStep: 10,
      icons: {
        up: "fas fa-chevron-up",
        down: "fas fa-chevron-down",
      },
    });
    $elem.find(".selectpicker").selectpicker("refresh");
    $elem.find("input[type='number']").not(".no-input-spinner").inputSpinner();
  }
}
